import React from "react";
import { Link } from "react-router-dom";

import Grid from "material-ui/Grid";
import Paper from "material-ui/Paper";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";

import {
  httpErrorCodes,
  styleSheet,
  authInfo,
  getOptionalHeadersForJob,
  renderApiInfo,
  otherApiClients,
} from "./api-shared";

const Api = (props) => {
  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <Paper>
            <Grid container className={props.classes.row}>
              <Grid item xs={12}>
                <p>
                  This document describes our "Webpage to PDF" functionality
                  (API endpoint), its associated HTTP header options, and
                  possible error responses. See{" "}
                  <Link to="/docs/api/pdf-examples">example usage here</Link> or
                  scroll down.
                </p>
                <p>
                  <strong>Endpoint:</strong>&nbsp;
                  <code>service.headless-render-api.com</code>
                </p>
                <p>
                  <strong>PDF Path:</strong>&nbsp;
                  <code>/pdf/$URL</code>
                </p>
                <p>
                  <strong>Example URL:</strong>&nbsp;
                  <pre>
                    <code>
                      https://service.headless-render-api.com/pdf/https://example.com/
                    </code>
                  </pre>
                </p>
                <p>
                  The target <code>$URL</code> is obviously part of the path,
                  but do not re-encode or re-escape it beyond what you'd enter
                  into a browser URL field. Both UTF-8 encoding and
                  percent-encoding are acceptable.
                </p>
                <p>
                  <strong>Related links:</strong>
                </p>
                <ul>
                  <li>
                    <Link to="/docs/api/pdf-examples">
                      examples of using the PDF API
                    </Link>
                  </li>
                  <li>
                    clients
                    <ul>{otherApiClients}</ul>
                  </li>
                </ul>
              </Grid>
            </Grid>
          </Paper>
          <h2 style={{ marginTop: 60, fontSize: 20, fontWeight: "bold" }}>
            Auth
          </h2>
          <Paper>
            <Grid container className={props.classes.row}>
              <Grid item xs={12}>
                Send your secret API token (you'll get it after creating an
                account) as a header with all your requests to avoid rate
                limiting.
              </Grid>
            </Grid>
            {renderApiInfo(authInfo, props, true)}
          </Paper>

          <h2 style={{ marginTop: 60, fontSize: 20, fontWeight: "bold" }}>
            Print webpage to PDF API
          </h2>
          <Paper>
            <Grid container className={props.classes.row}>
              <Grid item xs={12}>
                <p>
                  A print webpage to PDF API. Try it in your browser:&nbsp;
                  <a href="https://service.headless-render-api.com/pdf/https://example.com/">
                    service.headless-render-api.com/pdf/https://example.com
                  </a>
                </p>
                <Typography type="body2">
                  <strong>HTTP GET</strong>
                  <br />
                  service.headless-render-api.com/pdf/
                  <code
                    style={{
                      paddingTop: 0,
                      paddingBottom: 0,
                      paddingLeft: 3,
                      paddingRight: 3,
                    }}
                  >{`$URL`}</code>
                </Typography>
                <div style={{ fontSize: 10, marginLeft: 10 }}>
                  <p style={{ margin: "5px 0 0 0", fontWeight: "bold" }}>
                    cURL
                  </p>
                  <pre className={props.classes.inlinePre}>
                    <code>
                      curl
                      https://service.headless-render-api.com/pdf/https://example.com/
                      > out.pdf
                    </code>
                  </pre>

                  <p style={{ margin: "5px 0 0 0", fontWeight: "bold" }}>
                    Node.js client
                  </p>
                  <pre className={props.classes.inlinePre}>
                    <code>{`// npm install prerendercloud
await prerendercloud.pdf("https://example.com/", {
  // Note: using noPageBreaks forces the following
  //  - pageRanges: "1",
  //  - preferCssPageSize: true
  noPageBreaks: true,
  printBackground: true,

  // emulatedMedia options: (screen, print, braille, embossed, handheld, projection, speech, tty, tv)
  emulatedMedia: "screen",

  // pageRanges: "1-3",
  // scale: 1.5,  // Default: 1, min: 0.1, max: 2.0
  // preferCssPageSize: true,
  // printBackground: true,
  // landscape: true,
  // marginTop: 1.75,
  // marginRight: 0.5,
  // marginBottom: 1.75,
  // marginLeft: 0.5,
  // paperWidth: 8.5,
  // paperHeight: 11,
});`}</code>
                  </pre>
                </div>
              </Grid>
            </Grid>
            {renderApiInfo(getOptionalHeadersForJob("PDF"), props)}
          </Paper>

          <h2>HTTP Error Codes</h2>
          <Paper>{renderApiInfo(httpErrorCodes, props, true)}</Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styleSheet)(Api);



// WEBPACK FOOTER //
// ./src/PdfApi.js